<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="12"
            >
              <v-form ref="form_all">
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-receipt
                    </v-icon>Основные
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-tune
                    </v-icon>Настройки
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-folder
                    </v-icon>Файлы
                  </v-tab>
                  <v-tab v-if="form.type == 5">
                    <v-icon left>
                      mdi-dots-grid
                    </v-icon>Планограмма
                  </v-tab>
                  <v-tab-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.created"
                          label="Дата создания"
                          type="date"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.number"
                          label="Системный номер"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.state"
                          label="Статус"
                          :items="select.state"
                          :disabled="create || view"
                          @change="state_change"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.type"
                          label="Тип устройства"
                          :items="select.type"
                          :disabled="view"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.device"
                          label="Модель"
                          :items="select.device.filter(a=>a.type == form.type)"
                          item-text="model"
                          item-value="id"
                          :disabled="view || !form.type"
                          @change="device_selected"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.serial"
                          label="Серийный номер"
                          :disabled="view"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="form.client"
                          clearable
                          v-if="$store.state.access[14][5]"
                          :filter="client_filter"
                          :items="select.clients"
                          item-value="id"
                          label="Поиск клиента"
                          :disabled="view"
                          :loading="search.client.loading"
                          :search-input.sync="search.client.text"
                          hide-no-data
                          hint="Введите минимум три символа для поиска"
                        >
                          <template v-slot:selection="{item}">
                            <v-list>
                              <v-list-item-content>
                                <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list>
                          </template>
                          <template v-slot:item="{item}">
                            <v-list two-line>
                              <v-list-item-content>
                                <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                                <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.made"
                          type="date"
                          label="Дата производства"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.start"
                          type="date"
                          label="Дата ввода в эксплуатацию"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.end"
                          type="date"
                          label="Дата вывода из эксплуатации"
                          :disabled="true"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="form.comment"
                          label="Примечание"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                      v-if="select.device.filter(a=>a.id == form.device)[0]"
                      :items="select.device.filter(a=>a.id == form.device)[0].settings"
                      :headers="[
                        {value: 'description', text: 'Описание', width: 300},
                        {value: 'value', text: 'Значение', width: 150},
                      ]"
                      :footer-props="datatable_footer"
                      no-data-text="Нет данных для отображения"
                    >
                      <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                        {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                      </template>
                      <template v-slot:item.description="{item}">
                        <v-text-field
                          v-model="item.description"
                          readonly
                          @input="settings_change(item)"
                        />
                      </template>

                      <template v-slot:item.value="{item}">
                        <v-text-field
                          v-if="item.type == 0"
                          v-model="form.settings[item.key]"
                          @input="settings_change(item)"
                        />
                        <v-checkbox
                          v-if="item.type == 1"
                          v-model="form.settings[item.key]"
                          @change="settings_change(item)"
                        />
                        <v-select
                          v-if="item.type == 2"
                          v-model="form.settings[item.key]"
                          :items="item.values"
                          @change="settings_change(item)"
                        />
                        <v-textarea
                          v-if="item.type == 3"
                          v-model="form.settings[item.key]"
                          @input="settings_change(item)"
                        />
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item>
                    <v-form>
                      <v-container class="py-0">
                        <v-card
                          class="elevation-1"
                          text
                        >
                          <v-progress-linear
                            class="ma-0"
                            color="secondary"
                            :indeterminate="loader.show"
                          />
                          <v-card-text>
                            <v-data-table
                              hide-default-footer
                              hide-default-header
                              :items="form.files"
                              :headers="table.headers"
                              no-data-text="Нет данных для отображения"
                            >
                              <template v-slot:item.save="{item}">
                                <v-icon @click="getDoc(item)">
                                  mdi-content-save
                                </v-icon>
                              </template>
                              <template v-slot:item.comment="{item}">
                                <v-text-field
                                  v-model="item.comment"
                                  :disabled="loader.show || view"
                                  label="Описание"
                                />
                              </template>
                            </v-data-table>
                          </v-card-text>
                          <v-card-actions class="grey lighten-4">
                            <v-btn
                              color="primary"
                              text
                              :disabled="loader.show || view"
                              @click="$refs.upload.click()"
                            >
                              Добавить файл
                            </v-btn>
                            <input
                              ref="upload"
                              type="file"
                              style="display: none;"
                              @change="upload"
                            >
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-form>
                  </v-tab-item>
                  <v-tab-item v-if="form.type === 5">
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-data-table
                          :items="form.planogramm"
                          :headers="[{text: 'Код ячейки', value: 'number'}, {text: 'Тип', value: 'type'}, {text: 'Емкость ячейки', value: 'amount'}, {value: 'delete', text: ''}]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.number="{item}">
                            <v-text-field
                              v-model="item.number"
                              type="number"
                              label="Код ячейки"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.amount="{item}">
                            <v-text-field
                              v-model="item.amount"
                              type="number"
                              label="Емкость ячейки"
                              :disabled="item.type!=0"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.type="{item}">
                            <v-select
                              v-model="item.type"
                              label="Тип"
                              :items="[{value: 0, text: 'Товар'}, {value: 1, text: 'Рецепт'}, {value: 2, text: 'Платеж'}]"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.delete="{item}">
                            <v-icon
                              v-if="!item.new"
                              @click="form.planogramm = form.planogramm.filter(a=>a!=item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-btn
                        v-if="change"
                        color="primary"
                        large
                        min-width="100"
                        class="mr-5"
                        @click="save_equipment"
                      >
                        Сохранить
                      </v-btn>
                      <v-btn
                        v-if="create"
                        color="primary"
                        large
                        min-width="100"
                        class="mr-5"
                        @click="create_equipment"
                      >
                        Создать
                      </v-btn>
                      <v-btn
                        color="secondary"
                        large
                        min-width="100"
                        @click="$router.go(-1)"
                      >
                        Назад
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  export default {
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',
        },
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
      },
      tabs: [
        'Основные',
        'Настройки',
        'Файлы',
      ],
      data: {
        phone: '',
      },
      form: {
        files: [],
        settings: [
          {
            new: true,
            values: []
          }
        ],
        planogramm: [
          { new: true }
        ]
      },
      logs: [],
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
      },
      select: {
        clients: [],
        type: [
        ],
        state: [
          { value: 0, text: 'На складе' },
          { value: 1, text: 'Ожидает ввода в эксплуатацию' },
          { value: 2, text: 'Эксплуатируется' },
          { value: 3, text: 'Ремонт' },
          { value: 4, text: 'Утилизация' },
          { value: 5, text: 'Временно выведен из эксплуатации' }
        ],
        device: []
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {

            }
          }
        }
      },
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      this.axios.post('/api/device/list', {})
        .then(result => {
            if (!result.data.error) {
              this.select.device = result.data.data.filter(a => a.state == 0)
            }
          })
          .catch(e => {
            console.log(e)
          })
      for (const x in this.$store.state.dict.device_type) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.device_type[x].name
        })
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
      if (id) {
        this.axios.post('/api/equipment/list', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.schedule = this.form.schedule || {}
              this.form.planogramm = this.form.planogramm || []
              this.form.planogramm.push({ new: true })
              this.form.files = this.form.files || []
              if (this.form.start) this.form.start = moment(this.form.start).format('YYYY-MM-DD')
              if (this.form.end) this.form.end = moment(this.form.end).format('YYYY-MM-DD')
              if (this.form.made) this.form.made = moment(this.form.made).format('YYYY-MM-DD')
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      planogramm_change: function (item) {
        if (item.new) {
          item.new = false
          this.form.planogramm.push({
            new: true
          })
        }
      },
      device_selected: function () {
        if (this.form.device) {
          const device = this.select.device.filter(a => a.id == this.form.device)[0]
          if (device) {
            this.form.settings = {}
            if (device.planogramm) {
              this.form.planogramm = device.planogramm
              this.form.planogramm.push({ new: true })
            }
            for (const x in device.settings) {
              this.form.settings[device.settings[x].key] = device.settings[x].default_value
            }
          }
        }
      },
      client_filter: function (item, query, text) {
        if (item.legal && item.legal.name && item.legal.name.full && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && item.legal.name && item.legal.name.short && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {

          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }

                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      settings_change: function (item) {
        console.log(item)
        if (item.new) {
          item.new = false
          this.form.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          equipment: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (const x in result.data.data) {
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },

      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },

      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      create_equipment: function () {
        this.axios.post('/api/equipment/create', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$router.go(-1)
              } else {
                this.$store.commit('snackbar', result.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', e || 'Ошибка при сохранении данных')
            })
      },
      save_equipment: function () {
          this.axios.post('/api/equipment/save', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$emit('view', this.form.id)
              } else {
                this.$store.commit('snackbar', result.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', e || 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
